import { render, staticRenderFns } from "./BaseAccordions.vue?vue&type=template&id=64ba0642&scoped=true&"
import script from "./BaseAccordions.vue?vue&type=script&lang=js&"
export * from "./BaseAccordions.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccordions.vue?vue&type=style&index=0&id=64ba0642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba0642",
  null
  
)

export default component.exports